export default "__VITE_ASSET__$rGv4fSW__"